import { defineDocStore } from './base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import type { EmailList } from '@/types/email'
import { EmailListFactory } from '@/factories/emailListFactory'

export const useEmailListStore = defineDocStore<EmailList>({
  entityName: 'emailList',
  collection: 'email_lists',
  model: {
    create: EmailListFactory.create,
    normalize: undefined,
  },
  initialState: {
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      frequency: { value: null, matchMode: FilterMatchMode.EQUALS },
      description: { value: null, matchMode: FilterMatchMode.CONTAINS },
      tags: { value: null, matchMode: FilterMatchMode.CONTAINS },
    },
    sort: { field: 'name', order: 1 },
  },
})
